export const EMAIL_SIGNUP = "/email-signup";
